var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { staticClass: "link_close", on: { click: _vm.onClick } }, [
    _c("span", { staticClass: "ico_cafe ico_close" }, [_vm._v("닫기")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }